<template>
  <div class="pa-4">
    <v-skeleton-loader v-if="loading" class="mx-auto" type="card"></v-skeleton-loader>
    <div v-else>
      <v-card v-if="visitorData" style="margin-top:10px" class="pa-1" elevation="0">
        <v-card-title>
          <span class="mr-1" v-if="visitorData.rejectedDate">
            {{ $t('message.former_member') }}</span>
          <span class="mr-1" v-else>
            {{ $t('message.visitor') }}</span>
          <v-spacer></v-spacer>
          <ImageUpload v-if="visitorData.user && visitorData.user._id"
            :label="isSmallerDisplay() ? null : $t('message.update_profile_image')" :fab="true" :vm="this"
            :add-small="true" :success-function="successUploadImage">
          </ImageUpload>
        </v-card-title>
        <v-card-text class="text-center" v-if="visitorData.user && visitorImage">
          <v-avatar size="190">
            <ImageDisplay :src="visitorImage" />
          </v-avatar>
        </v-card-text>
        <v-card outlined v-if="visitorData.entryPackages && visitorData.entryPackages.length > 0">
          <v-list class="text-left pa-1">
            <v-subheader v-if="visitorData.rejectedDate">
              {{ $t("message.memberships") }}
            </v-subheader>
            <v-subheader v-else>
              {{ $t("message.entry_packages") }}
            </v-subheader>
            <template v-for="(i, index) in visitorData.entryPackages">
              <v-list-item :key="'entry_package' + i._id" @click="goToTransaction(i._id)">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ i.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="i.subscriptionCheckins">{{ i.checkins }} /
                    {{ i.subscriptionCheckins }} {{ $t('message.checkins') }}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else-if="i.subscriptionEndDate">{{ $t('message.expires') }}:
                    {{ $d(new Date(i.subscriptionEndDate), "month_day_year", $i18n.locale) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="index + 1 < visitorData.entryPackages.length"
                :key="'entry_package_divider_' + index"></v-divider>
            </template>
          </v-list>
        </v-card>
        <v-list class="text-left">
          <v-list-item v-if="visitorData.rejectedDate">
            <v-list-item-action>
              <v-icon color="error">mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $d(new Date(visitorData.rejectedDate), "short", $i18n.locale) }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ $t('message.removed_from_academy') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="visitorData.firstVisit">
            <v-list-item-action>
              <v-icon>mdi-clock-time-eight-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $d(new Date(visitorData.firstVisit), "short", $i18n.locale) }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ $t('message.visit_date') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="visitorData.firstVisit"></v-divider>
          <v-list-item v-if="visitorData.prospect">
            <v-list-item-action>
              <v-icon>mdi-clipboard-check-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $d(new Date(visitorData.created), "short", $i18n.locale) }}
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.form_submitted') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="visitorData.prospect"></v-divider>
          <v-list-item v-if="visitorData.referralAffiliate"
            @click="navigateTo(({ name: 'manageaffiliate', params: { id: visitorData.referralAffiliate._id } }))">
            <v-list-item-action>
              <v-icon>mdi-account-tie-voice-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ visitorData.referralAffiliate.displayName }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ $t('message.referred_by') }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar v-if="visitorData.referralAffiliate.userImageSmall">
              <ImageDisplay :src="visitorData.referralAffiliate.userImageSmall" />
            </v-list-item-avatar>
          </v-list-item>
          <v-divider v-if="visitorData.referralAffiliate"></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account-circle-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field dense @blur="updatevisitorData()" v-model="visitorData.name"></v-text-field>
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.name') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-at</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field dense :disabled="visitorData.invalidEmail ? false : true"
                  v-model="visitorData.email"></v-text-field>
              </v-list-item-title>
              <v-list-item-title><span v-if="!visitorData.invalidEmail">{{ $t('message.email') }}</span>
                <v-btn v-if="!visitorData.invalidEmail" class="ml-1" icon x-small
                  @click="copyEmail()"><v-icon>mdi-content-copy</v-icon></v-btn>
                <span class="ml-1 error--text" v-if="!isValidEmail(visitorData.email)">{{ $t('message.invalid_email')
                  }}</span>
                <v-btn outlined color="primary" v-if="visitorData.invalidEmail" class="ml-1" text x-small
                  @click="updateEmail()">{{ $t('message.update') }}</v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-phone</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field dense :placeholder="$t('message.type_to_edit')" @blur="updatevisitorData()"
                  v-model="visitorData.phone"></v-text-field>
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.phone') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-home-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field dense :placeholder="$t('message.type_to_edit')" @blur="updatevisitorData()"
                  v-model="visitorData.address"></v-text-field>
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.address') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-car-brake-alert</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field dense :placeholder="$t('message.type_to_edit')" @blur="updatevisitorData()"
                  v-model="visitorData.emergencyContact"></v-text-field>
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.emergency_contact') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-account-multiple-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field dense :placeholder="$t('message.type_to_edit')" @blur="updatevisitorData()"
                  v-model="visitorData.guardian"></v-text-field>
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.guardian') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item v-if="visitorData.unsubscribed">
            <v-list-item-action>
              <v-icon color="error">mdi-account-voice</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("message.unsubscribed_on", [$d(new Date(visitorData.unsubscribed), "month_day_year",
                  $i18n.locale)]) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t("message.communication") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="visitorData.unsubscribed"></v-divider>
          <v-list-item>
            <v-list-item-action>
              <v-icon>mdi-label-multiple-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <v-combobox outlined dense v-model="visitorData.tags" :items="availableTags" :hide-no-data="!tagsSearch"
                  :search-input.sync="tagsSearch" chips multiple @input="updateTags">
                  <template slot="no-data">
                    <v-list-item>
                      <span class="subheading">{{ $t('message.click_enter_add_new') }}:</span>
                      <v-chip label small>{{ tagsSearch }}</v-chip>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-list-item-title>
              <v-list-item-title>{{ $t('message.labels') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <v-card v-if="visitorData" class="mt-2" elevation="0">
        <v-card-actions>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn outlined color="primary" block v-on="on" elevation="0" small slot="activator" left>
                <v-icon class="mr-1">mdi-dots-vertical</v-icon>
                {{ $t("message.actions") }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click.stop="navigateTo({ name: 'calendar', query: { v: visitorId } })">
                <v-list-item-title>
                  <v-icon class="mr-1">mdi-calendar-check</v-icon>
                  {{ $t("message.add_visit") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click.stop="visitorToMemberDialog()">
                <v-list-item-title>
                  <v-icon class="mr-1">mdi-account-plus-outline</v-icon>
                  {{ $t("message.add_member") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-allowed="'sell_items'" @click.stop="goToSellItem()">
                <v-list-item-title>
                  <v-icon class="mr-1">mdi-cart-outline</v-icon>
                  {{ $t("message.sell_item") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-allowed="'sell_items'" v-if="visitorData.user" @click.stop="goToSellMembership()">
                <v-list-item-title>
                  <v-icon class="mr-1">mdi-ticket-confirmation-outline</v-icon>
                  {{ $t("message.sell_manual_membership") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-show="false" @click.stop="sendEmailDialog = true">
                <v-list-item-title>
                  <v-icon class="mr-1">mdi-email-outline</v-icon>
                  {{ $t("message.send_email") }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-card-actions>
        <v-card-actions v-if="visitorData.onboardingTransaction">
          <v-btn elevation="0" :loading="completingOnboarding"
            v-if="visitorData.onboardingTransaction.subscription && !visitorData.onboardingTransaction.completed && visitorData.onboardingTransaction.sessionStatus == 'complete'"
            @click="completePublicMembership()" block color="secondary">
            {{ $t('message.complete_onboarding') }}
          </v-btn>
          <v-btn elevation="0" v-if="visitorData.onboardingTransaction.completed" @click="visitorToMemberDialog()" block
            color="secondary">
            {{ $t('message.complete_onboarding') }}
          </v-btn>
          <v-btn v-else @click="goToTransaction(visitorData.onboardingTransaction._id)" block color="secondary">
            {{ $t('message.view_pending_transaction') }}
          </v-btn>
        </v-card-actions>
        <v-card-title>
          <v-icon>mdi-text-box-edit-outline</v-icon>
          {{ $t('message.notes') }}
        </v-card-title>
        <v-card-text>
          <v-textarea rows="3" filled :placeholder="$t('message.type_to_edit')" @blur="updatevisitorData()"
            v-model="visitorData.notes"></v-textarea>
        </v-card-text>
      </v-card>
      <v-expansion-panels v-model="memberPanels" elevation="0" flat>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="visitorData && visitorData.timeline && visitorData.timeline.length > 0">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <v-icon class="mr-1">mdi-map-marker-path</v-icon>
              {{ $t("message.visitor_journey") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-timeline align-top dense>
              <v-timeline-item v-for="(item, index) in visitorData.timeline" :key="'timeline_' + index"
                :color="timelineColor(item.type)" fill-dot dark>
                <template v-slot:icon>
                  <v-icon :color="isDarkMode() ? 'black' : 'white'" small>{{ timelineIcon(item.type) }}</v-icon>
                </template>
                <div :class="['tl-item', $store.state.theme === 'light' ? 'tl-item--light' : 'tl-item--dark']">
                  <div class="text-subtitle-2">{{ timelineLabel(item) }}</div>
                  <div class="text-caption grey--text">{{ $d(new Date(item.date), "long", $i18n.locale) }}</div>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'" v-if="visitorData">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <span class="mt-2"><v-icon>mdi-comment-text-outline</v-icon></span>
              {{ $t("message.comments") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <MemberComments :data="visitorData" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!visitorData.notBjjUser"
          :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getMemberBeltHistory()">
            <div class="text-left">
              <icon-belt color="grey"></icon-belt>
              {{ $t("message.belt_history") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list class="text-left">
              <template v-for="(i, index) in beltHistory">
                <v-list-item :key="'belt_history_' + index">
                  <v-list-item-content>
                    <v-list-item-title>
                      <belt-display :belt="i.belt" :show-text="isSmallerDisplay() ? false : true" />
                      <span class="ml-1" v-if="isSmallerDisplay()">{{ displayBeltDay(i.date) }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="i.daysAtRank">
                      {{ $t("message.days_at_belt") }} <b>{{ i.daysAtRank }}</b>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="i.classesAtRank">
                      {{ $t("message.classes_at_rank") }} <b>{{ i.classesAtRank }}</b>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content v-if="!isSmallerDisplay()">
                    <v-list-item-title>
                      {{ displayBeltDay(i.date) }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn @click.stop="deleteMemberBeltHistory(i._id)" small icon>
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index + 1 < beltHistory.length" :key="'belthistory_divider_' + index"></v-divider>
              </template>
            </v-list>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined elevation="0" color="primary" :block="isSmallerDisplay() ? true : false"
                @click.stop="showUpdateSocialProfileDialog('belt')">
                {{ $t("message.update_belt") }}
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getAcademyLists()">
            <div class="text-left">
              <v-icon>mdi-chevron-double-up</v-icon>
              {{ capitalizeFirstLetter($t("message.levels")) }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-actions v-if="!isSmallerDisplay()">
              <div class="text-caption">
                <v-icon size="15">mdi-information-slab-circle-outline</v-icon>
                {{ $t("message.alternative_levels_explained") }}
              </div>
              <v-spacer></v-spacer>
              <v-btn outlined elevation="0" color="primary" @click="addLevelDialog = true">{{ $t("message.add")
                }}</v-btn>
            </v-card-actions>
            <div v-else>
              <v-btn outlined elevation="0" block color="primary" @click="addLevelDialog = true">{{ $t("message.add")
                }}</v-btn>
            </div>
            <v-card-text>
              <div class="text-center" v-if="alternativeLevels.length == 0">
                {{ $t("message.no_data") }}
              </div>
              <v-list v-else>
                <template v-for="(i, index) in alternativeLevels">
                  <v-list-item :key="'alt_level_' + index">
                    <v-list-item-content class="text-subtitle-1">
                      <v-list-item-title>
                        <v-chip small color="accent">{{ i.sport }} : {{ i.name }}</v-chip>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $d(new Date(i.date), "month_day_year", $i18n.locale) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn small icon
                        @click="removeAlternativelevel(i, index)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getAcademyLists()">
            <div class="text-left">
              <v-icon>mdi-label-multiple-outline</v-icon>
              {{ $t("message.key_value_pairs") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="text-caption">{{ $t("message.key_value_pairs_explained") }}</div>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-combobox dense outlined hide-details chips v-model="newKeyValuePair.key"
                    :items="availableMemberKeys" :label="$t('message.key')" clearable></v-combobox>
                </v-col>
                <v-col>
                  <v-combobox dense outlined hide-details chips v-model="newKeyValuePair.value"
                    :items="availableMemberValues" :label="$t('message.value')" clearable></v-combobox>
                </v-col>
                <v-col>
                  <v-btn outlined color="primary" small elevation="0"
                    :disabled="!newKeyValuePair.key || !newKeyValuePair.value ? true : false"
                    @click="addNewKeyValuePair()">
                    {{ $t("message.add") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <template v-for="(entry, index) in visitorData.valuePairs">
                <v-card-actions :key="'key_vaue_pair_' + index">
                  <v-chip small>{{ entry.key }}</v-chip>
                  <span class="text-subtitle-1 ml-1 mr-1">:</span>
                  <v-chip small class="mr-1">{{ entry.value }}</v-chip>
                  <v-spacer></v-spacer>
                  <v-btn small icon class="ml-1" @click="removeKeyValuePair(index)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-btn outlined elevation="0" color="primary" block small @click="updateKeyValuePairs()">
                {{ $t("message.update") }}
              </v-btn>
            </v-card-actions>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="visitorData && visitorData.academyFormExtraFields">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <span class="mt-2"><v-icon>mdi-list-box-outline</v-icon></span>
              {{ $t("message.contact_form_extra_values") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <template v-for="(field, index) in visitorData.academyFormExtraFields">
              <v-card-actions :key="'extra_field_' + index">
                <v-text-field dense disabled :key="'extra_field_' + index" :label="field.fieldName"
                  v-model="field.value"></v-text-field>
                <v-spacer></v-spacer>
                <v-btn small icon @click="copyToClipboard(field.value)">
                  <v-icon size="25">mdi-content-copy</v-icon>
                </v-btn>
              </v-card-actions>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="loadAttendance()">
            <v-card-text class="pa-0">
              <v-icon>mdi-map-marker-outline</v-icon>
              {{ $t("message.attendance") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card elevation="0">
              <div v-if="loadingAttendance">
                <v-skeleton-loader class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
              </div>
              <div v-else>
                <v-list v-if="attendance.length > 0">
                  <v-subheader>
                    {{ $t("message.last_x", [25]) }}
                  </v-subheader>
                  <template v-for="(checkin, index) in attendance">
                    <v-list-item :key="checkin._id">
                      <v-list-item-action class="mr-4">
                        <v-icon v-if="checkin.source == 'tablet'">mdi-tablet</v-icon>
                        <v-icon v-else-if="checkin.source == 'manual'">mdi-laptop</v-icon>
                        <v-icon v-else>mdi-cellphone</v-icon>
                      </v-list-item-action>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>
                          <span>
                            {{ $d(new Date(checkin.date), "long", $i18n.locale) }}
                          </span>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span v-if="checkin.name && checkin.name != ''">
                            {{ $t("message.class") }} - {{ checkin.name }}
                          </span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-tooltip v-if="checkin.membershipStatus" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon
                              @click="goToTransaction(checkin.membershipStatusTransaction)">
                              <v-icon
                                :color="getTransactionStatusColor(checkin.membershipStatus)">mdi-ticket-confirmation-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("message." + checkin.membershipStatus) }}</span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider v-if="index + 1 < attendance.length" :key="index"></v-divider>
                  </template>
                </v-list>
                <div class="text-body-2" v-else>{{ $t("message.nothing_to_show") }}</div>
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="loadTransactions()">
            <v-card-text class="pa-0">
              <v-icon>mdi-cart-check</v-icon>
              {{ $t("message.transactions") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card elevation="0">
              <div v-if="loadingTransactions">
                <v-skeleton-loader class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
              </div>
              <div v-else>
                <v-list v-if="transactions && transactions.length > 0">
                  <template v-for="(i, index) in transactions">
                    <v-list-item :key="i._id" @click="goToItemsTransaction(i)">
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-icon size="15" color="accent"
                            v-if="i.coupon && i.coupon.discountedTotal > 0">mdi-tag-outline</v-icon>
                          {{ currencySymbol + getTransactionTotal(i) }} - {{ i.product ? i.product.name : '' }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ $d(new Date(i.completed), 'long', $i18n.locale) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < transactions.length" :key="index"></v-divider>
                  </template>
                </v-list>
                <div class="text-body-2" v-else>{{ $t("message.nothing_to_show") }}</div>
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="getEmails()">
            <div class="text-left">
              <v-icon>mdi-email-fast-outline</v-icon>
              {{ $t("message.sent_emails") }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content v-if="emails">
            <div v-if="!emails || emails.length == 0" class="text-center text-cubtitle-1 primary--text">
              {{ $t("message.no_member_emails") }}
            </div>
            <v-skeleton-loader v-if="loadingEmails"
              type="list-item-avatar, divider, list-item-avatar, divider, list-item-avatar"></v-skeleton-loader>
            <div class="text-caption" v-else-if="emails.length > 50">{{ $t("message.showing_first_results_only",
              [50]) }}</div>
            <template v-for="(e, index) in emails">
              <v-list-item two-line :key="'update' + index" class="text-left" @click="getEmail(e)">
                <v-list-item-content>
                  <v-list-item-title>
                    <span v-if="e.opening">
                      <v-progress-circular size="15" width="5" indeterminate color="secondary"></v-progress-circular>
                    </span>
                    <span v-else>{{ e.subject }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ $d(new Date(e.time), "long", $i18n.locale) }}
                    <v-icon class="ml-1" size="20" v-if="e.failed" color="error">mdi-email-alert-outline</v-icon>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="e.source == 'sequence-automations'">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="accent" v-bind="attrs" v-on="on" size="20">mdi-robot-industrial-outline</v-icon>
                    </template>
                    <span>{{ $t("message.automations") }}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-action>
                  <v-badge color="secondary" :content="e.recipients">
                    <v-icon size="20" v-if="e.recipients == 1">mdi-account-outline</v-icon>
                    <v-icon size="20" v-else-if="e.recipients == 2">mdi-account-multiple-outline</v-icon>
                    <v-icon size="20" v-else>mdi-account-group-outline</v-icon>
                  </v-badge>
                </v-list-item-action>
              </v-list-item>
              <v-divider v-if="index + 1 < emails.length" :key="index"></v-divider>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
          <v-expansion-panel-header @click="loadVisitorActivities()">
            <v-card-text class="pa-0">
              <v-icon>mdi-account-details</v-icon>
              {{ $t("message.admin_activities") }}
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card elevation="0">
              <div v-if="loadingActivities">
                <v-skeleton-loader class="mx-auto" type="list-item-three-line"></v-skeleton-loader>
              </div>
              <div v-else>
                <v-list v-if="visitorActivities && visitorActivities.length > 0">
                  <template v-for="(i, index) in visitorActivities">
                    <v-list-item :key="i._id">
                      <v-list-item-avatar v-if="i.user && i.user.userImageSmall">
                        <ImageDisplay :src="i.user.userImageSmall" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t("message." + i.action) }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ $d(new Date(i.time), 'long', $i18n.locale) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < visitorActivities.length" :key="index"></v-divider>
                  </template>
                </v-list>
                <div class="text-body-2" v-else>{{ $t("message.nothing_to_show") }}</div>
              </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'"
          v-if="documents.length > 0">
          <v-expansion-panel-header>
            <v-card-text class="pa-0">
              <v-icon>mdi-clipboard-check-outline</v-icon>
              {{ $t('message.documents') }} ({{ documents.length }})
            </v-card-text>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card-text>
              <v-list class="text-left">
                <template v-for="(i, index) in documents">
                  <v-list-item :key="'document_' + index" @click="print(i)">
                    <v-list-item-content>
                      <v-list-item-title>
                        <span v-if="i.template">{{ i.template.name }}</span>
                        <span v-else>{{ $t('message.main_tablet_waiver') }}</span>
                      </v-list-item-title>
                      <v-list-item-title v-if="i.time">
                        <span style="color:gray">{{ $d(new Date(i.time), 'long', $i18n.locale) }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="index + 1 < documents.length" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card class="mt-2" outlined elevation="0">
        <v-card-actions>
          <v-btn elevation="0" small @click="goBack()">
            {{ $t('message.back') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="error" small @click="archiveVisitorDialog = true">
            {{ $t('message.archive') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <v-dialog v-model="archiveVisitorDialog">
      <v-card outlined>
        <v-card-text class="text-h5">
          {{ $t('message.are_you_sure') }}
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="error" @click="archiveVisitor()">{{ $t('message.archive') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" @click="archiveVisitorDialog = false;">
            {{ $t('message.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newUserDialog" max-width="90%">
      <div outlined>
        <v-card>
          <v-card-text>
            <div class="ml-4 mt-4 text-subtitle-1">{{ $t('message.add_member') }}</div>
            <div class="pl-4 pr-4 pt-2 pb-2">
              <v-form ref="form" lazy-validation>
                <v-switch dense style="display:inline-block" :label="$t('message.is_minor')" v-model="newUser.isMinor">
                </v-switch>
                <v-text-field @keyup="checkExistingUser(newUser)" label="Email" v-model="newUser.email" required
                  outlined dense>
                </v-text-field>
                <div v-if="!existingNewUser || newUser.isMinor">
                  <v-switch dense :label="$t('message.not_bjj_user')" v-model="newUser.notBjjUser"></v-switch>
                  <v-icon v-if="newUser.isMinor" :color="themeColor('primary')"
                    class="ml-2 mb-2">mdi-baby-face-outline</v-icon>
                  <v-icon v-else-if="newUser.notBjjUser" :color="themeColor('primary')"
                    class="ml-2 mb-2">mdi-account-remove-outline</v-icon>
                  <v-text-field :label="$t('message.first_name')" v-model="newUser.fName" autocomplete="false" required
                    outlined dense></v-text-field>
                  <v-text-field :label="$t('message.last_name')" v-model="newUser.lName" required outlined dense>
                  </v-text-field>
                  <GenderSelect :icon="false" v-model="newUser.gender"
                    v-show="!newUser.existing || !newUser.existing.gender" />
                  <v-text-field type="password" :label="$t('message.password')" v-model="newUser.password"
                    autocomplete="new-password" required outlined dense v-show="!newUser.existing"></v-text-field>
                  <BeltsSelect v-if="!newUser.notBjjUser" v-model="newUser.belt"
                    v-show="!newUser.existing || !newUser.existing.belt" />
                  <v-card-text class="mt-0 pl-0 pt-0">
                    <div class="text-subtitle-2">{{ $t('message.birthday') }}</div>
                    <date-picker :show-time="false" v-model="newUserDob" :past-event="true">
                    </date-picker>
                  </v-card-text>
                  <CountriesSelect v-model="newUser.nationality"
                    v-show="!newUser.existing || !newUser.existing.nationality" />
                  <v-switch :disabled="newUser.isMinor" :label="$t('message.old_enough')" v-model="newUser.ageMin">
                  </v-switch>
                </div>
                <div v-else>
                  <div v-if="existingNewUser.alreadyMember" class="error--text">{{ $t("message.already_member") }}</div>
                  <div v-else class="primary--text">{{ $t("message.existing_bjjlink_user") }}</div>
                  <v-list>
                    <v-list-item>
                      <v-list-item-avatar v-if="existingNewUser.image">
                        <ImageDisplay :src="existingNewUser.image" />
                      </v-list-item-avatar>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>
                          {{ existingNewUser.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          {{ existingNewUser.academyName }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions class="ml-6 mb-4">
            <v-btn outlined :loading="registring" v-if="existingNewUser && !newUser.isMinor" small elevation="0"
              @click="registerExistingUser()" color="primary" :disabled="existingNewUser.alreadyMember">
              {{ $t("message.add_existing_user") }}
            </v-btn>
            <v-btn v-else :loading="registring" outlined small elevation="0" @click="registerNewUser()" color="primary"
              :disabled="!newUserReady()">
              {{ $t("message.add_member") }}
            </v-btn>
            <v-btn small elevation="0" @click="newUserDialog = false; newUser = {}">
              <span>{{ $t("message.close") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="addLevelDialog" max-width="90%">
      <v-card class="text-left" elevation="0" outlined>
        <v-card-title>
          {{ $t("message.add_new_level") }}
        </v-card-title>
        <v-card-text>
          <v-combobox :label="$t('message.level')" v-model="newLevel.name" :items="availableLevels"
            :hide-no-data="!levelSearch" :search-input.sync="levelSearch" small-chips outlined dense>
            <template slot="no-data">
              <v-list-item>
                <span class="subheading">{{ $t("message.click_enter_add_new") }}:</span>
                <v-chip class="mr-1" label small>{{ levelSearch }}</v-chip>
              </v-list-item>
            </template>
          </v-combobox>
          <v-combobox :label="$t('message.sport')" v-model="newLevel.sport" :items="availableSports"
            :hide-no-data="!sportSearch" :search-input.sync="sportSearch" small-chips outlined dense>
            <template slot="no-data">
              <v-list-item>
                <span class="subheading">{{ $t("message.click_enter_add_new") }}:</span>
                <v-chip class="mr-1" label small>{{ sportSearch }}</v-chip>
              </v-list-item>
            </template>
          </v-combobox>
          <DatePicker :show-time="false" v-model="newLevel.date" :past-event="true"></DatePicker>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined small elevation="0" color="primary" @click="addNewLevel()">{{
            $t("message.add")
            }}</v-btn>
          <v-btn small elevation="0" @click="addLevelDialog = false">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editSocialProfileDialog" max-width="80%">
      <v-card class="text-xs-left pa-1" v-if="socialProfileUpdateData" elevation="0" outlined>
        <v-card-title>
          {{ socialProfileUpdateData.title }}
        </v-card-title>
        <v-card-text>
          <v-switch v-if="socialProfileUpdateData.attribute == 'isMinor'" v-model="socialProfileUpdateData.value">
          </v-switch>
          <div v-else-if="socialProfileUpdateData.attribute == 'dob'">
            <div class="text-subtitle-2">{{ $t('message.dob') }}</div>
            <DatePicker :show-time="false" v-model="socialProfileUpdateData.date" :past-event="true">
            </DatePicker>
          </div>
          <div v-else-if="socialProfileUpdateData.attribute == 'belt'">
            <belts-select v-model="socialProfileUpdateData.value" :show-icon="false" />
            <div class="text-subtitle-2">{{ $t('message.date_given') }}</div>
            <DatePicker :show-time="false" v-model="socialProfileUpdateData.date" :past-event="true">
            </DatePicker>
          </div>
          <div v-else-if="socialProfileUpdateData.attribute == 'nationality'">
            <countries-select v-model="socialProfileUpdateData.value" />
          </div>
          <v-text-field dense outlined v-else v-model="socialProfileUpdateData.value"
            :label="$t('message.enter_new_value')">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="updatingSocialProfile" small elevation="0" color="primary"
            @click="updateSocialProfile()">{{
              $t("message.update")
            }}</v-btn>
          <v-btn small elevation="0" @click="editSocialProfileDialog = false; socialProfileUpdateData = null">{{
            $t("message.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendEmailDialog" max-width="90%">
      <v-card class="text-xs-left" elevation="0" outlined>
        <v-card-title>
          {{ $t('message.send_email_to') }}: <b>{{ visitorData ? visitorData.name : '' }}</b>
        </v-card-title>
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.subject')" v-model="emailSubject"></v-text-field>
        </v-card-text>
        <v-card-text>
          <v-combobox v-model="customEmails" :label="$t('message.custom_email_addresses')"
            :hint="$t('message.custom_emails_hint')" persistent-hint chips multiple outlined dense deletable-chips
            small-chips :error-messages="emailErrors" @input="validateEmails">
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close small
                :color="isValidEmail(data.item) ? 'secondary' : 'error'" dark @click="data.select"
                @click:close="removeEmail(data.item)">
                {{ data.item }}
              </v-chip>
            </template>
          </v-combobox>
        </v-card-text>
        <v-card-text>
          <v-textarea outlined v-model="emailContents" :label="$t('message.email_body')" rows="6"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :loading="sendingEmail" small elevation="0" color="primary" :disabled="!canSendEmail"
            @click="sendEmailToVisitor()">
            {{ $t("message.send") }}
          </v-btn>
          <v-btn small elevation="0" @click="closeSendEmailDialog()">
            {{ $t("message.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="emailDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card outlined>
        <v-toolbar dense flat color="primary">
          <v-spacer></v-spacer>
          <v-btn icon small @click="emailDialog = false; email = null;">
            <v-icon color="opposite">mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card v-if="email" class="pa-2">
          <v-card-actions style="color:gray">
            <v-avatar size="20">
              <ImageDisplay v-if="email.sender && email.sender.userImageSmall" :src="email.sender.userImageSmall" />
              <img v-else :src="assets('default-profile-avatar.png')" />
            </v-avatar>
            <span v-if="email.sender" class="ml-1">{{ email.sender.displayName }}</span>
            <v-spacer></v-spacer>
            {{ $d(new Date(email.time), "short", $i18n.locale) }}
          </v-card-actions>
          <v-card-title v-if="email.error" class="text-caption error--text">{{ email.error }}</v-card-title>
          <v-card class="pa-2" outlined>
            <v-card-title>
              <span class="text-subtitle-1">{{ $t("message.recipients") }}:</span>
              <template v-for="(r, index) in email.recipients">
                <v-chip :key="'recipient' + index" v-if="r && r != ''" small class="ma-1">{{ r }}</v-chip>
              </template>
            </v-card-title>
            <v-card-title>
              <span class="text-subtitle-1">{{ $t("message.subject") }}:</span>
              <span style="margin-left:5px">{{ email.subject }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="email.contents"></div>
            </v-card-text>
          </v-card>
          <v-card outlined class="mt-1" v-if="email.openedBy && email.openedBy.length">
            <v-card-title>
              <span class="text-subtitle-1">{{ $t("message.opened_by") }}:</span>
            </v-card-title>
            <v-list>
              <v-list-item dense v-for="i in email.openedBy" :key="'opened_email_' + i._id">
                <v-list-item-content>
                  <v-list-item-title>{{ i.user ? i.user.email : i.email }}</v-list-item-title>
                  <v-list-item-subtitle>{{ $d(new Date(i.time), "long", $i18n.locale) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BeltDisplay from "@/components/displays/BeltDisplay.vue";
import IconBelt from "@/components/displays/icons/IconBelt.vue";
import MemberComments from "@/components/displays/MemberComments.vue";
import BeltsSelect from "@/components/inputs/BeltsSelect.vue";
import CountriesSelect from "@/components/inputs/CountriesSelect.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import GenderSelect from "@/components/inputs/GenderSelect.vue";
import ImageUpload from "@/components/inputs/ImageUploadCroppie.vue";
import Api from "@/services/Api";
import Api2 from "@/services/Api2";
import { Environment } from "@/services/Environment";


export default {
  data() {
    return {
      visitorId: this.$route.params.visitorId,
      userId: null,
      loading: true,
      visitorData: null,
      documents: [],
      availableTags: [],
      attendance: [],
      transactions: [],
      loadingAttendance: false,
      loadingTransactions: false,
      loadingActivities: false,
      visitorActivities: [],
      tagsSearch: null,
      visitorImage: null,
      isMember: false,
      previousData: {},
      currencySymbol: '$',
      archiveVisitorDialog: null,
      newUserDialog: null,
      newUser: {},
      memberPanels: null,
      registring: false,
      newUserDob: null,
      availableMemberKeys: [],
      availableMemberValues: [],
      newKeyValuePair: {},
      addLevelDialog: null,
      sportSearch: null,
      availableSports: [],
      alternativeLevels: [],
      existingNewUser: null,
      availableLevels: [],
      levelSearch: null,
      newLevel: {},
      beltHistory: null,
      socialProfileUpdateData: false,
      editSocialProfileDialog: null,
      updatingSocialProfile: false,
      sendEmailDialog: false,
      emailDialog: false,
      email: null,
      emails: [],
      loadingEmails: false,
      sendingEmail: false,
      emailSubject: "",
      emailContents: "",
      customEmails: [],
      emailErrors: [],
      successUploadImage: function (uploadedFileData, vm) {
        if (vm && uploadedFileData) {
          vm.submitUpdatePicture(uploadedFileData);
        }
      },
    };
  },
  components: {
    DatePicker,
    CountriesSelect,
    BeltsSelect,
    GenderSelect,
    MemberComments,
    ImageUpload,
    IconBelt,
    BeltDisplay
  },
  beforeRouteUpdate(to, from, next) {
    this.visitorId = to.params.visitorId;
    this.loadVisitorData();
    next();
  },
  created() {
    this.getAvailableTags();
    this.loadVisitorData();
  },
  watch: {},
  computed: {
    canSendEmail() {
      const hasUserEmail = this.visitorData && this.visitorData.user && this.visitorData.user._id;
      const hasCustomEmails = this.customEmails && this.customEmails.length > 0 && this.emailErrors.length === 0;
      const hasValidRecipients = hasUserEmail || hasCustomEmails;
      return hasValidRecipients && this.emailSubject && this.emailContents;
    }
  },
  methods: {
    timelineIcon(type) {
      const map = {
        first_visit: "mdi-door-open",
        last_visit: "mdi-clock-outline",
        trial_class_booked: "mdi-calendar-star",
        trial_class_attended: "mdi-check-circle",
        trial_class_noshow: "mdi-close-circle",
        inquiry: "mdi-message-text-outline",
        email_read: "mdi-email-open-outline",
      };
      return map[type] || "mdi-circle-outline";
    },
    timelineColor(type) {
      const map = {
        first_visit: "primary",
        last_visit: "primary",
        trial_class_booked: "accent",
        trial_class_attended: "success",
        trial_class_noshow: "error",
        inquiry: "accent",
        email_read: "accent",
      };
      return map[type] || "grey";
    },
    timelineLabel(item) {
      const labelMap = {
        first_visit: this.$t("message.first_visit"),
        last_visit: this.$t("message.last_visit"),
        trial_class_booked: this.$t("message.trial_class_booked"),
        trial_class_attended: this.$t("message.trial_class"),
        trial_class_noshow: this.$t("message.trial_class_noshow"),
        inquiry: this.$t("message.inquiry_submitted"),
        email_read: this.$t("message.email_read"),
      };
      const base = labelMap[item.type] || item.type;
      return item.title ? base + " – " + item.title : base;
    },
    getEmail(email = {}) {
      email.opening = true;
      const id = email._id ? email._id : 'grouped';
      Api2()
        .get(
          "admins/academy/" + this.$store.state.managedAcademy + "/emails/" + id + '?' +
          (email.group ? 'group=' + email.group : '')
        )
        .then((response) => {
          this.email = response.data.email;
          this.emailDialog = true;
          email.opening = false;
        });
    },
    getEmails() {
      this.loadingEmails = true;
      let options = { email: this.visitorData.email, source: 'all' };

      Api()
        .post("admins/academy/" + this.$store.state.managedAcademy + "/emails", options)
        .then((response) => {
          this.emails = response.data.emails;
          this.loadingEmails = false;
        });
    },
    completePublicMembership() {
      this.completingOnboarding = true;
      let sessionId = null;
      if (this.visitorData.onboardingTransaction && this.visitorData.onboardingTransaction.sessionId) {
        sessionId = this.visitorData.onboardingTransaction.sessionId;
      } else {
        this.showAlert("error", "Invalid Session");
        return;
      }
      if (sessionId) {
        Api2()
          .get(
            "payments/academy/" +
            this.$store.state.managedAcademy +
            "/complete/public/onboarding?status=success&s=" + sessionId
          )
          .then(() => {
            this.goToTransaction(this.visitorData.onboardingTransaction._id)
          });
      } else {
        console.log('Cannot auto resume onboarding. ', this.transactionId)
        this.completingOnboarding = false;
        this.showAlert("error", this.$t('message.error_generic'));
      }
    },
    registerExistingUser() {
      if (!this.existingNewUser || !this.existingNewUser._id) {
        this.showAlert("error", this.$t("message.fill_all_params"));
        return;
      } else {
        this.registring = true;
        Api()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/connect/existing/" + this.existingNewUser._id,
          )
          .then((response) => {
            try {
              if (response.data) {
                this.newUserDialog = false;
                this.registring = false;
                //this.newUser = {};
                const newUser = response.data;
                this.loading = false;
                //Load members again and approve this new member
                if (newUser.isMinor) {
                  this.approveMember(newUser);
                } else {
                  this.approveMember(newUser);
                }
                this.$emit('refresh-search');
              }
            } catch (e) {
              console.log(e);
              this.showAlert("error", this.$t('message.error_generic'));
            }
          })
          .catch(() => {
            this.registring = false;
            this.showAlert("error", this.$t('message.error_generic'));
          });
      }
    },
    getMemberBeltHistory() {
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.userId + "/history/belt")
        .then(response => {
          if (response && response.data.history && response.data.history.length > 0) {
            this.beltHistory = response.data.history;
          }
        });
    },
    updateSocialProfile() {
      this.updatingSocialProfile = true;
      if (this.socialProfileUpdateData.date) {
        let d = new Date(this.socialProfileUpdateData.date);
        d.setHours(1);
        d.setMinutes(0);
        this.socialProfileUpdateData.date = d;
        if (this.socialProfileUpdateData.attribute == 'dob')
          this.socialProfileUpdateData.value = d;
      }
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/member/" + this.userId + '/social', this.socialProfileUpdateData)
        .then(response => {
          if (response) {
            this.showAlert("success", this.$t('message.success'));
            //Update user
            if (this.socialProfileUpdateData.attribute == 'belt') {
              this.getMemberBeltHistory();
            }
            this.editSocialProfileDialog = false;
            this.socialProfileUpdateData.date = null;
            this.socialProfileUpdateData.value = null;
            this.updatingSocialProfile = false;
          }
        })
        .catch(e => {
          this.updatingSocialProfile = false;
          if (e.response.data.message_translation)
            this.showAlert("error", "Oops!", this.$t("message." + e.response.data.message_translation));
          else
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    showUpdateSocialProfileDialog(attribute) {
      this.editSocialProfileDialog = true;
      this.socialProfileUpdateData = {
        attribute: attribute,
        value: null
      }; if (attribute == 'dob') {
        this.socialProfileUpdateData.title = this.$t("message.dob");
        if (this.visitorData.dob)
          this.socialProfileUpdateData.date = this.dateFromStringInTZ(this.visitorData.dob);
      } if (attribute == 'belt') {
        this.socialProfileUpdateData.title = this.$t("message.update_belt");
        this.socialProfileUpdateData.value = this.visitorData.belt;
      }
    },
    deleteMemberBeltHistory(id) {
      Api()
        .delete(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/member/" +
          this.memberId +
          "/history/" + id
        )
        .then((response) => {
          if (response.data) {
            this.getMemberBeltHistory();
            this.showAlert("success", this.$t("message.removed"));
          }
        });
    },
    removeAlternativelevel(level, index) {
      Api()
        .delete(
          "admins/managedacademy/" + this.$store.state.managedAcademy + "/members/" + this.userId + "/levels/" + level._id
        )
        .then(() => {
          this.alternativeLevels.splice(index, 1);
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    addNewLevel() {
      if (!this.newLevel.date)
        this.newLevel.date = new Date();
      Api()
        .patch(
          "admins/managedacademy/" + this.$store.state.managedAcademy + "/members/" + this.userId + "/levels",
          { level: this.newLevel }
        )
        .then(() => {
          this.alternativeLevels.push(this.newLevel);
          this.addLevelDialog = false;
          this.newLevel = {};
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });

    },
    getAcademyLists() {
      Api2()
        .get(
          "admins/managedacademy/" +
          this.$store.state.managedAcademy +
          "/lists"
        )
        .then((response) => {
          if (response && response.data) {
            this.availableMemberKeys = response.data.keys;
            this.availableLevels = response.data.levels;
            this.availableSports = response.data.sports;
            this.availableMemberValues = response.data.values;
          }
        });
    },
    addNewKeyValuePair() {
      this.visitorData.valuePairs.push(this.newKeyValuePair);
      this.newKeyValuePair = { key: null, value: null };
    },
    removeKeyValuePair(index) {
      this.visitorData.valuePairs.splice(index, 1);
    },
    updateKeyValuePairs() {
      Api2()
        .patch(
          "admins/managedacademy/" + this.$store.state.managedAcademy + "/visitors/" + this.visitorId + "/key-values",
          { valuePairs: this.visitorData.valuePairs }
        )
        .then(() => {
          this.showAlert("success", this.$t("message.updated"));
        })
        .catch(() => {
          this.showAlert("error", this.$t('message.error_generic'));
        });
    },
    loadVisitorData() {
      this.loading = true;
      Api2()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/visitor/" +
          this.visitorId +
          "/data"
        )
        .then(response => {
          if (response.data) {
            this.visitorData = response.data;
            if (this.visitorData && this.visitorData.user && this.visitorData.user.userImageSmall)
              this.visitorImage = this.visitorData.user.userImageSmall;
            if (!this.visitorData.visitor && this.visitorData.user) {
              //Not a visitor, FW to member
              this.goToMember(this.visitorData.user._id);
            }
            if (!this.isValidEmail(this.visitorData.email))
              this.visitorData.invalidEmail = true;
            if (this.visitorData.user)
              this.userId = this.visitorData.user._id;
            this.loading = false;
            if (this.visitorData && this.visitorData.alternativeLevels)
              this.alternativeLevels = this.visitorData.alternativeLevels;
            if (this.visitorData.user) {
              const postData = {
                user: this.visitorData.user._id,
                email: this.visitorData.email
              };
              Api2()
                .post(
                  "documents/academy/" +
                  this.$store.state.managedAcademy +
                  "/completed",
                  postData
                )
                .then(response => {
                  if (response.data && response.data.length > 0)
                    this.documents = response.data;
                });
            }
          }
        });
    },
    submitUpdatePicture(data) {
      const newImage = data.location;
      const smallerFile = data.smallImageLocation;
      let userId = this.visitorData.user && this.visitorData.user._id ? this.visitorData.user._id : this.visitorData.user;
      Api2()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/member/" + userId + '/image',
          {
            userImage: newImage,
            userImageSmall: smallerFile
          })
        .then(response => {
          if (response) {
            this.visitorImage = data.original;
            if (response)
              this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        });
    },
    copyEmail() {
      this.copyToClipboard(this.visitorData.email);
    },
    goToSellItem() {
      this.navigateTo({ name: "bulksell", query: { email: this.visitorData.email } });
    },
    goToSellMembership() {
      this.navigateTo({ name: "sellproduct", query: { userId: this.visitorData.user._id, visitorEmail: this.visitorData.email }, params: { productId: 'manual-membership' } });
    },
    loadTransactions() {
      this.loadingTransactions = true;
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/visitor/" + this.visitorId + '/transactions')
        .then(response => {
          if (response) {
            if (response.data && response.data.transactions) {
              this.transactions = response.data.transactions.data;
              this.currencySymbol = response.data.transactions.currencySymbol;
            }
            this.loadingTransactions = false;
          }
        })
        .catch((err) => {
          console.log('error: ', err)
          this.loadingTransactions = false;
        });
    },
    loadVisitorActivities() {
      this.loadingActivities = true;
      Api2()
        .get("admins/managedacademy/" + this.$store.state.managedAcademy + "/visitor/" + this.visitorId + '/activities')
        .then(response => {
          if (response) {
            if (response.data && response.data.activities) {
              this.visitorActivities = response.data.activities;
            }
            this.loadingActivities = false;
          }
        })
        .catch((err) => {
          console.log('error: ', err)
          this.loadingTransactions = false;
        });
    },
    loadAttendance() {
      this.loadingAttendance = true;
      Api2()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/visitor/" + this.visitorId + '/attendance')
        .then(response => {
          if (response) {
            if (response.data && response.data.attendance.checkins) {
              this.attendance = response.data.attendance.checkins;
            }
            this.loadingAttendance = false;
          }
        })
        .catch((err) => {
          console.log('error: ', err)
          this.loadingAttendance = false;
        });
    },
    registerNewUser() {
      try {
        if (this.newUserDob) {
          let d = new Date(this.newUserDob);
          d.setHours(0);
          d.setMinutes(0);
          this.newUser.dob = d;
        }
        this.registring = true;
        if (this.newUser.password) {
          let buff = new Buffer(this.newUser.password);
          let base64data = buff.toString("base64");
          this.newUser.password = base64data;
        }
        this.newUser.academy = this.$store.state.selectedAcademy;
        if (this.newUser.notBjjUser) this.newUser.belt = "white";
        this.newUser.existing = null;
        Api2()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/new_member",
            this.newUser
          )
          .then((response) => {
            try {
              if (response.data) {
                this.newUserDialog = false;
                this.registring = false;
                //this.newUser = {};
                const newUser = response.data;
                this.loading = false;
                this.$emit('refresh-search');
                //Load members again and approve this new member
                if (newUser.isMinor) {
                  this.approveMember(newUser);
                } else {
                  this.approveMember(newUser);
                }
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch((e) => {
            this.registring = false;
            if (e.response.status == 409) {
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.already_a_user"),
                9000
              );
            } else {
              this.showAlert("error", "Oops!", "Error :(");
            }
          });
      } catch (err) {
        console.log(err)
      }

    },
    visitorToMemberDialog() {
      if (this.visitorData) {
        const visitor = this.visitorData;
        this.newUser = {};
        if (visitor.user) {
          Api2()
            .post("admins/academy/" + this.$store.state.managedAcademy + "/new_member/visitor/" + visitor._id)
            .then((response) => {
              try {
                if (response.data) {
                  this.newUserDialog = false;
                  this.registring = false;
                  this.approveMember(response.data, false);
                  this.showAlert("success");
                }
              } catch (e) {
                console.log(e);
              }
            })
            .catch((e) => {
              this.registring = false;
              if (e)
                this.showAlert("error", "Oops!", "Error :(");
            });
          return;
        } else {
          if (visitor.name) {
            const split = visitor.name.split(' ');
            if (split) {
              if (split[0])
                this.newUser.fName = split[0];
              if (split[1])
                this.newUser.lName = split[1];
            }
          }
          this.newUser.email = visitor.email;
          this.checkExistingUser(this.newUser);
          this.newUserDialog = true;
          this.newUser.visitorId = visitor._id;
        }
      }
    },
    newUserReady() {
      if (
        this.newUser.fName &&
        this.newUser.lName &&
        this.newUser.email &&
        (this.newUser.password || this.newUser.existing) &&
        this.newUser.nationality &&
        (this.newUser.notBjjUser || this.newUser.belt) &&
        (this.newUser.ageMin || this.newUser.isMinor)
      ) {
        return true;
      }
      return false;
    },
    loadPreviousData(visitorData) {
      this.previousData = {
        name: visitorData ? visitorData.name : null,
        address: visitorData ? visitorData.address : null,
        emergencyContact: visitorData ? visitorData.emergencyContact : null,
        guardian: visitorData ? visitorData.guardian : null,
        phone: visitorData.phone,
        notes: visitorData ? visitorData.notes : null
      };
    },
    getAvailableTags() {
      Api2()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/tags")
        .then(response => {
          if (response.data) {
            this.availableTags = response.data.sort();
          }
        })
        .catch(e => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    approveMember(member) {
      let data = { members: [member._id] };
      Api2()
        .post(
          "admins/academy/" + this.$store.state.selectedAcademy + "/approve",
          data
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.navigateTo({ name: 'members' })
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updateTags() {
      Api2()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/visitor/" +
          this.visitorId +
          "/data",
          { tags: this.visitorData.tags }
        )
        .then(response => {
          if (response.data) {
            this.showAlert("success", this.$t("message.success"));
          }
        });
    },
    updateEmail() {
      Api2()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/visitor/" +
          this.visitorId +
          "/data",
          { email: this.visitorData.email }
        )
        .then(response => {
          if (response.data) {
            this.visitorData.invalidEmail = false;
            this.showAlert("success", this.$t("message.success"));
          }
        }).catch(() => {
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updatevisitorData() {
      if (
        this.previousData.name != this.visitorData.name ||
        this.previousData.phone != this.visitorData.phone ||
        this.previousData.notes != this.visitorData.notes ||
        this.previousData.address != this.visitorData.address ||
        this.previousData.emergencyContact !=
        this.visitorData.emergencyContact ||
        this.previousData.guardian != this.visitorData.guardian
      ) {
        const visitorData = {
          address: this.visitorData.address,
          emergencyContact: this.visitorData.emergencyContact,
          guardian: this.visitorData.guardian,
          notes: this.visitorData.notes,
          phone: this.visitorData.phone,
          name: this.visitorData.name
        };
        Api2()
          .patch(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/visitor/" +
            this.visitorId +
            "/data/",
            visitorData
          )
          .then(response => {
            if (response.data) {
              this.showAlert("success", this.$t("message.success"));
              this.loadPreviousData(this.visitorData);
            }
          });
      }
    },
    print(item) {
      window.open(Environment.get("VUE_APP_ASSETS_HOME") + "secure/printwaiver/" + item._id, "_blank");
    },
    archiveVisitor() {
      Api2()
        .delete("admins/academy/" + this.$store.state.managedAcademy + "/visitors/" + this.visitorId)
        .then((response) => {
          if (response.data) {
            this.navigateTo({
              name: "memberstab",
              params: { tabId: 2 },
            });
          }
        });
    },
    goToTransaction(id) {
      if (id) {
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: id } });
      }
    },
    goToItemsTransaction(t) {
      if (t && t.category == 'membership')
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: t._id } });
      else
        this.navigateTo({ name: 'viewitemstransaction', params: { transactionId: t._id } });
    },
    closeSendEmailDialog() {
      this.sendEmailDialog = false;
      this.emailSubject = "";
      this.emailContents = "";
      this.customEmails = [];
      this.emailErrors = [];
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    validateEmails() {
      this.emailErrors = [];
      const invalidEmails = this.customEmails.filter(email => !this.isValidEmail(email));
      if (invalidEmails.length > 0) {
        this.emailErrors = [`Invalid email(s): ${invalidEmails.join(', ')}`];
      }
    },
    removeEmail(email) {
      const index = this.customEmails.indexOf(email);
      if (index >= 0) {
        this.customEmails.splice(index, 1);
      }
      this.validateEmails();
    },
    sendEmailToVisitor() {
      this.sendingEmail = true;
      this.validateEmails();

      const recipients = [];
      if (this.visitorData && this.visitorData.user && this.visitorData.user._id) {
        recipients.push(this.visitorData.user._id);
      }

      const validCustomEmails = this.customEmails.filter(email => this.isValidEmail(email));
      const hasRecipients = recipients.length > 0 || validCustomEmails.length > 0;

      if (hasRecipients && this.emailContents && this.emailSubject && this.emailErrors.length === 0) {
        const postData = {
          recipients: recipients,
          subject: this.emailSubject,
          contents: this.emailContents,
          bcc: validCustomEmails,
          sendCopy: false
        };

        Api()
          .post(
            "admins/v2/academy/" + this.$store.state.managedAcademy + "/send/emails",
            postData
          )
          .then((response) => {
            if (response.data) {
              this.showAlert("success", "Oss!", ":)");
              this.closeSendEmailDialog();
            }
            this.sendingEmail = false;
          })
          .catch((e) => {
            this.sendingEmail = false;
            if (e) this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      } else {
        this.sendingEmail = false;
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    }
  }
};
</script>

<style scoped>
.tl-item {
  border-radius: 6px;
  padding: 6px 10px;
  margin-left: 4px;
}

.tl-item--light {
  border: 1px solid #e0e0e0;
}

.tl-item--dark {
  border: 1px solid #424242;
}
</style>
